import type { Table } from "@tanstack/react-table";
import type { IEquipo } from "../../../modelos/Equipo/entidades/IEquipo";
import type { ICatalogo } from "../../../globales/interfaces";
import type { IModeloEquipo } from "../../../modelos/Equipo/entidades/IModeloEquipo";
import type { IFiltroEquipo } from "../../../modelos/Equipo/entidades/IFiltroEquipo";

export interface ITablaEquiposVistaProps {
    tabla: Table<IEquipo>;
    equipoSeleccionado: IEquipo;
    manejarCambioValorEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    agregarEditarEquipo: () => void;
    entidadesEquipo: IEntidadesEquipo;
    agregarError: (campo: keyof IEquipo, error: string) => Promise<void>;
    errores: Partial<Record<keyof IEquipo, string | null>>
      filtro: IFiltroEquipo;
    consultarEquipos: (filtros?: IFiltroEquipo) => void;
    manejarCambioFiltroEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    // entidadesEquipo: IEntidadesEquipo;
    limpiarFiltros: () => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    habilitarFormulario: boolean;
    manejarHabilitarFormulario: (habilitar: boolean) => void;
    descargarPlantilla: () => Promise<void>;
    cargaMasivaEquipos: () => void;
    pantallaCompleta?: boolean;
    tipoContratoActivo: number | null;
}

export const estadoInicialEquipo: IEquipo = {
    Id: 0,
    ProyectoId: 0,
    Codigo: '',
    Nombre: '',
    TipoEquipoId: 0,
    MarcaId: 0,
    ModeloId: null,
    Adoptado: false,
    Pisos: 0,
    Paradas: 0,
    Entradas: 0,
    Capacidad: 0,
    Angulo: 0,
    Altura: 0,
    Ancho: 0,
    Velocidad: 0,
    EstadoEquipoId: 0,
    TaxonomiaJson: '',
    QrCode: '',
    InstaladoUtc: '',
    Activo: true,
    Eliminado: false,
    CreadoUtc: '',
    ActualizadoUtc: '',

    // NBS Fields
    Ken: null,
    Control: null,
    FechaFirmaPlanos: null,
    FechaFirmaAcabados: null,
    FechaFirmaContrato: null,
    FechaPagoAnticipo: null,
    APF: null,
    FechaFinalInstalacionProyectada: null,

    // DTOs opcionales
    TipoEquipo: undefined,
    Modelo: undefined,
    Marca: undefined,
    EstadoEquipo: undefined,
    Proyecto: undefined,
    Zona: undefined,
};


export interface IEstadoEquipo extends ICatalogo {
    TipoContratoId?: number | null;
}

export interface IEntidadesEquipo {
    TiposEquipo: ICatalogo[];
    MarcasEquipo: ICatalogo[];
    ModelosEquipo: IModeloEquipo[];
    ModelosEquipoFiltrados: IModeloEquipo[];
    EstadosEquipo: IEstadoEquipo[]
}

export interface IFormularioEquipoVistaProps {
    equipoSeleccionado: IEquipo;
    manejarCambioValorEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    agregarEditarEquipo: () => void;
    entidadesEquipo: IEntidadesEquipo;
    agregarError: (campo: keyof IEquipo, error: string) => Promise<void>;
    errores: Partial<Record<keyof IEquipo, string | null>>;
    tipoContratoActivo: number | null;
}

export interface IEquiposCVProps {
    idProyecto: number;
    pantallaCompleta?: boolean;
}

export interface IFiltroEquiposVistaProps {
    filtro: IFiltroEquipo;
    consultarEquipos: (filtros?: IFiltroEquipo) => void;
    manejarCambioFiltroEquipo: (campo: keyof IEquipo, valor: IEquipo[keyof IEquipo]) => void;
    entidadesEquipo: IEntidadesEquipo;
    limpiarFiltros: () => void;
}